/* eslint-disable consistent-return */
import { Button, Grid } from '@material-ui/core';
import { postStudentInterest } from '@webapps/business';
import {
  FormikTextField,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import Information from 'components/Icons/Information';

const interestSchema = yup.object().shape({
  label: yup.string().required('Requis'),
});

const AddInterest = ({ close, refetch }) => {
  const { css, global, cx } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateInterest,
  } = useMutation(postStudentInterest);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      label: '',
    },
    validationSchema: interestSchema,
    onSubmit: async (values) => {
      await mutateInterest({
        data: values,
        id: idUser,
      });
    },
  });

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
        <div className={css({display: "flex", justifyContent: 'center', alignItem: 'center', marginTop: 8})}>
        <Information className={css({height: 22, width: 22, color: "#0060F9", marginRight: 10 })} />
          <div className={cx(css({marginBottom: '12px'}), global.infoText)}>
            Vous aimez le football ? L’architecture, les sciences ou tout simplement les jeux vidéos ?
            Indiquez vos centres d’intérêts permettent aux recruteurs de mieux connaitre et de créer une alchimie entre les différents collaborateurs de l’entreprise.</div>
      </div>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              borderRadius={6}
              inputProps={{ maxLength: 50 }}
              label="Intitulé du centre d'intérêt"
              name="label"
            />
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddInterest.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  deleteInterest: PropTypes.func,
};

export default AddInterest;
